import React from 'react';
import emptyStyles from 'components/UI/V3/Table/EmptyState/TableEmptyState.module.scss';
import textStyles from 'components/UI/V3/Table/EmptyState/DefaultTableEmptyState.module.scss';

interface NoResultsProps {
    title: string;
    description: Array<string>;
}

// Same look as DefaultTableEmptyState, for lists that aren't a <table> (that one renders a <tr>).
export const NoResults: React.FC<NoResultsProps> = ({ title, description }) => (
    <div className={emptyStyles.root}>
        <p className={textStyles.title}>{title}</p>
        {description.map(line => (
            <p
                key={line}
                className={textStyles.descriptionLine}
            >
                {line}
            </p>
        ))}
    </div>
);

export default NoResults;
